import { combineReducers } from 'redux'

// reducers per store
import {
  updateUserDetails,
  updateUserPermissionForFolder,
  updateActiveMenu,
} from './userReducer'
import {
  updateSharedUserDetails,
  updateSharedFolderDetails,
  updateSharedFolderPath,
} from './sharedUserReducer'

import {
  updateFileListBasedOnFilter,
  updateFileListFromResponse,
  updateFolderList,
  updateFilesToUpload,
  updateSelectedFolderToSearch,
} from './fileReducer'

import {
  updateLimit,
  updatePageNo,
  updateSortBy,
  updateSortType,
  updateStartDate,
  updateEndDate,
  updateBaseFolder,
} from './queryParamReducer'

const rootReducer = combineReducers({
  baseFolder: updateBaseFolder,
  user: updateUserDetails,
  files: updateFileListBasedOnFilter,
  fileList: updateFileListFromResponse,
  folderList: updateFolderList,
  sharedUserList: updateSharedUserDetails,
  pageNo: updatePageNo,
  limit: updateLimit,
  sortType: updateSortType,
  sortBy: updateSortBy,
  startDate: updateStartDate,
  endDate: updateEndDate,
  filesToUpload: updateFilesToUpload,
  userPermission: updateUserPermissionForFolder,
  sharedFolderDetails: updateSharedFolderDetails,
  shareePath: updateSharedFolderPath,
  selectedFolderToSearch: updateSelectedFolderToSearch,
  activeMenu: updateActiveMenu,
})

export default rootReducer
